import { Box } from '@mantine/core';

// Зелёный прямоугольный ярлык-заголовок — фирменный мотив сайта (ServiceTab с лендинга),
// перенесённый в кабинет. Используется для подзаголовков данных (классы товара в «Купить»,
// далее — «Продать», «Сделки»). Не выглядит кнопкой: без hover/cursor.
export default function SectionLabel({ children }: { readonly children: React.ReactNode }) {
  return (
    <Box
      component="span"
      bg="brand.6"
      c="white"
      fw={600}
      fz="sm"
      px={10}
      py={4}
      // Без скругления — точное соответствие фирменному мотиву (ServiceTab на лендинге).
      style={{ display: 'inline-block', width: 'fit-content' }}
    >
      {children}
    </Box>
  );
}
